
import { Vue, Component, Prop } from 'vue-property-decorator';
import { getYPositionsOfElements, getSelectionFromVisibleSections, scrollToElement } from '@/utils/helpers';

@Component<Sidebar>({})
export default class Sidebar extends Vue {
	@Prop({ type: Array, required: false, default: () => {} }) private elements!: Menu[] | MenuSection[];

	private currentElementIdx: number = 0;
	private windowHeight: number = 0;

	/**
	 * Add the scroll event and set the window height
	 *
	 * @return {void}
	 */
	private created(): void {
		window.addEventListener('scroll', this.handleScroll);
		this.windowHeight = window.innerHeight;
	}

	/**
	 * Add the resize event
	 *
	 * @return {void}
	 */
	private mounted(): void {
		window.addEventListener('resize', this.handleResize);
	}

	/**
	 * Remove resize listener
	 *
	 * @return {void}
	 */
	private beforeDestroy(): void {
		window.removeEventListener('resize', this.handleResize);
	}

	/**
	 * Remove scroll listener
	 *
	 * @return {void}
	 */
	private destroyed(): void {
		window.removeEventListener('scroll', this.handleScroll);
	}

	/**
	 * Scroll to the respective menu or section selected
	 *
	 * @param {MenuSection} section
	 * @param {number} sIdx
	 * @return {void}
	 */
	private scrollToSelectedElement(section: MenuSection, sIdx: number): void {
		scrollToElement(section, sIdx, 35);
	}

	/**
	 * Listen to the scroll event and set the selected menu or section based on Y axis
	 *
	 * @return {void}
	 */
	private handleScroll(): void {
		const yPositions: number[] = getYPositionsOfElements(this.elements);
		this.currentElementIdx = getSelectionFromVisibleSections(yPositions, this.windowHeight);
	}

	/**
	 * Update window height on viewport resize
	 *
	 * @return {void}
	 */
	private handleResize(): void {
		this.windowHeight = window.innerHeight;
	}
}
